import { render, staticRenderFns } from "./PageAids.vue?vue&type=template&id=16c2e11c"
import script from "./PageAids.vue?vue&type=script&lang=js"
export * from "./PageAids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports